import { Container } from "../Container/Container";

export class Item extends Container {
}
